import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { AppService } from '@app/app.service';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';

export class BaseService {
  constructor(private http: HttpClient, public _appService: AppService) {}

  protected handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      console.error(error); // Log error to console
      console.log(`${operation} failed: ${error.message}`);
      return of(result as T);
    };
  }

 protected get(url: string, options?: { params?: HttpParams }): Observable<any> {
  return this.http
    .get(url, options)
    .pipe(catchError(this.handleError('get')));
}

  protected post(url: any, formData: FormData): Observable<any> {
    return this.http
      .post(url, formData)
      .pipe(catchError(this.handleError('post')));
  }

  protected put(url: any, formData: FormData): Observable<any> {
    return this.http
      .put(url, formData)
      .pipe(catchError(this.handleError('put')));
  }

  protected delete(url: any): Observable<any> {
    return this.http
      .delete(url)
      .pipe(catchError(this.handleError('delete')));
  }
}